/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_TraceInputs */

const en_svtag_trace = /** @type {(inputs: Svtag_TraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TRACE`)
};

const ar_svtag_trace = /** @type {(inputs: Svtag_TraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#تتبع`)
};

const bn_svtag_trace = /** @type {(inputs: Svtag_TraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TRACE`)
};

const de_svtag_trace = /** @type {(inputs: Svtag_TraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TRACE`)
};

const es_svtag_trace = /** @type {(inputs: Svtag_TraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TRACE`)
};

const fr_svtag_trace = /** @type {(inputs: Svtag_TraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TRACE`)
};

const pt_svtag_trace = /** @type {(inputs: Svtag_TraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TRACE`)
};

const zh_svtag_trace = /** @type {(inputs: Svtag_TraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TRACE`)
};

const tr_svtag_trace = /** @type {(inputs: Svtag_TraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TRACE`)
};

const ru_svtag_trace = /** @type {(inputs: Svtag_TraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TRACE`)
};

const pl_svtag_trace = /** @type {(inputs: Svtag_TraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TRACE`)
};

/**
* | output |
* | --- |
* | "#TRACE" |
*
* @param {Svtag_TraceInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_trace = /** @type {((inputs?: Svtag_TraceInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_TraceInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_trace(inputs)
	if (locale === "bn") return bn_svtag_trace(inputs)
	if (locale === "de") return de_svtag_trace(inputs)
	if (locale === "es") return es_svtag_trace(inputs)
	if (locale === "fr") return fr_svtag_trace(inputs)
	if (locale === "pt") return pt_svtag_trace(inputs)
	if (locale === "zh") return zh_svtag_trace(inputs)
	if (locale === "tr") return tr_svtag_trace(inputs)
	if (locale === "ru") return ru_svtag_trace(inputs)
	if (locale === "pl") return pl_svtag_trace(inputs)
	return en_svtag_trace(inputs)
});